import axios from 'axios'
import isObject from 'lodash/isObject'

export const ENTRYPOINT = process.env.REACT_APP_API_URL

const handleFilesUpload = async (data) => {
    const findDeep = async (object) => {
        if (object) {
            for (const key in object) {
                if (key === 'rawFile') {
                    object = await postFile(object[key])
                } else if (isObject(object[key])) {
                    object[key] = await findDeep(object[key])
                }
            }
        }

        return object
    }

    data = await findDeep(data)

    return data
}

const postFile = async (file) => {
    const formData = new FormData()

    formData.append('file', new File([file], file.name))

    return axios
        .post(`${ENTRYPOINT}/api/media`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
            },
        })
        .then((response) => response.data['@id'])
        .catch((error) => {
            console.error(error)
        })
}

export default handleFilesUpload
